(function ($) {
    var searchTimeout = null;

    $.expr[":"].contains = $.expr.createPseudo(function(arg) {
        return function( elem ) {
            return $(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
        };
    });

    var openAccordion = function ($els) {
        $els.each(function () {
            var $el = $(this);

            $el.addClass('active');
            $($el.attr('href')).removeClass('d-none').addClass('show');
        });
    };

    var closeAccordion = function ($els) {
        $els.each(function () {
            var $el = $(this);

            $el.removeClass('active');
            $($el.attr('href')).removeClass('show').addClass('d-none');
        });
    };

    var filterHazardRegister = function () {
        RISSB.fn.block();

        var $accordions = {
            dataTypeContext: $('[data-type="context"]'),
            dataContextId: $('[data-context-id]'),
            dataTypeSource: $('[data-type="source"]'),
            dataSourceId: $('[data-source-id]'),
            dataTypePrecursor: $('[data-type="precursor"]'),
            dataPrecursorId : $('[data-precursor-id]'),
            searchableNodes: $('.hazard-register-accordion').find('[data-search]'),
        };

        var contexts = $('input[name="context[]"]:checked').map(function () {
            return $(this).val();
        }).get();

        var sources = $('input[name="source[]"]:checked').map(function () {
            return $(this).val();
        }).get();

        var precursors = $('input[name="precursor[]"]:checked').map(function () {
            return $(this).val();
        }).get();

        var keyword  = $.trim($('.js-hazard-register-search').val()).toLowerCase();
        var isSearch = keyword !== '';
        var selector = ':contains("' + keyword.toLowerCase() + '")';

        // Start handling checkbox visibility
        if (contexts.length) {
            $accordions.dataContextId.addClass('d-none').removeClass('d-block');

            $.each(contexts, function (key, context_id) {
                $accordions.dataContextId.filter('[data-context-id="' + context_id + '"]').removeClass('d-none').addClass('d-block');
            });
        } else {
            $accordions.dataContextId.removeClass('d-none').addClass('d-block');
        }

        if (sources.length) {
            $accordions.dataSourceId.addClass('d-none').removeClass('d-block');

            $.each(sources, function (key, source_id) {
                $accordions.dataSourceId.filter('[data-source-id="' + source_id + '"]').removeClass('d-none').addClass('d-block');
            });
        } else {
            $accordions.dataSourceId.removeClass('d-none').addClass('d-block');
        }

        if (precursors.length) {
            $accordions.dataPrecursorId.addClass('d-none').removeClass('d-block');

            $.each(precursors, function (key, precursor_id) {
                $accordions.dataPrecursorId.filter('[data-precursor-id="' + precursor_id + '"]').removeClass('d-none').addClass('d-block');
            });
        } else {
            $accordions.dataPrecursorId.removeClass('d-none').addClass('d-block');
        }
        // End handling checkbox visibility

        $accordions.dataTypeContext.addClass('d-none');

        if (contexts.length) {
            $.each(contexts, function (key, context_id) {
                if (isSearch) {
                    $accordions.dataTypeContext.filter('[data-id="' + context_id + '"]').filter(selector).removeClass('d-none');
                    openAccordion($accordions.dataTypeContext.filter('[data-id="' + context_id + '"]').filter(selector).find('.js-collapse'));
                } else {
                    $accordions.dataTypeContext.filter('[data-id="' + context_id + '"]').removeClass('d-none');
                }
            });
        } else {
            if (isSearch) {
                $accordions.dataTypeContext.filter(selector).removeClass('d-none');
                openAccordion($accordions.dataTypeContext.filter(selector).find('.js-collapse'));
            } else {
                $accordions.dataTypeContext.removeClass('d-none');
            }
        }

        $accordions.dataTypeSource.addClass('d-none');

        if (sources.length) {
            $.each(sources, function (key, source_id) {
                if (isSearch) {
                    $accordions.dataTypeSource.filter('[data-id="' + source_id + '"]').filter(selector).removeClass('d-none');
                    openAccordion($accordions.dataTypeSource.filter('[data-id="' + source_id + '"]').filter(selector).find('.js-collapse'));
                } else {
                    $accordions.dataTypeSource.filter('[data-id="' + source_id + '"]').removeClass('d-none');
                }
            });
        } else {
            if (isSearch) {
                $accordions.dataTypeSource.filter(selector).removeClass('d-none');
                openAccordion($accordions.dataTypeSource.filter(selector).find('.js-collapse'));
            } else {
                $accordions.dataTypeSource.removeClass('d-none');
            }
        }

        $accordions.dataTypePrecursor.addClass('d-none');

        if (precursors.length) {
            $.each(precursors, function (key, precursor_id) {
                if (isSearch) {
                    $accordions.dataTypePrecursor.filter('[data-id="' + precursor_id + '"]').filter(selector).removeClass('d-none');
                    openAccordion($accordions.dataTypePrecursor.filter('[data-id="' + precursor_id + '"]').filter(selector).find('.js-collapse'));
                } else {
                    $accordions.dataTypePrecursor.filter('[data-id="' + precursor_id + '"]').removeClass('d-none');
                }
            });
        } else {
            if (isSearch) {
                $accordions.dataTypePrecursor.filter(selector).removeClass('d-none');
                openAccordion($accordions.dataTypePrecursor.filter(selector).find('.js-collapse'));
            } else {
                $accordions.dataTypePrecursor.removeClass('d-none');
            }
        }

        RISSB.fn.unblock();
    };

    $(document).ready(function () {
        if ($('body').hasClass('page-template-template-hazard-register-search-page') || $('body').hasClass('page-template-template-hazard-register-export-page')) {
            if ($('.js-auto-hazard-register-login-modal').length) {
                $('#modal-hazard-register-login').modal('show');
            }

            var $accordionCollapse = $('.hazard-register-accordion .collapse');

            RISSB.fn.clearDropdownFilter(filterHazardRegister);

            $('.js-toggle-hazard-register-accordion').on('click', function(e) {
                e.preventDefault();

                var $this = $(this);

                if ($this.data('state') === 'expand') {
                    $accordionCollapse.addClass('show').removeClass('d-none');
                    $this.text('Shrink all')
                    $this.data('state', 'shrink');
                } else {
                    $accordionCollapse.addClass('d-none').removeClass('show');
                    $this.text('Expand all')
                    $this.data('state', 'expand');
                }
            });

            $('.js-update-filter').on('click', function (e) {
                e.preventDefault();
                filterHazardRegister();
                $(this).closest('.dropdown-menu').removeClass('show');
            });

            $('.js-hazard-register-search').on('keyup input', function () {
                clearTimeout(searchTimeout);
                searchTimeout = setTimeout(filterHazardRegister, 500);
            });

            $('.js-collapse').on('click', function (e) {
                e.preventDefault();

                var $this = $(this);

                if ($($this.attr('href')).hasClass('show')) {
                    closeAccordion($this);
                } else {
                    openAccordion($this);
                }
            });
        }

        if ($('body').hasClass('page-template-template-hazard-register-content-page') || $('body').hasClass('page-template-template-hazard-register-details-page')) {
            if ($('.js-auto-hazard-register-login-modal').length) {
                $('#modal-hazard-register-login').modal('show');
            }

            $(document).on('click', '.js-quick-preview', function (e) {
                e.preventDefault();
               $('#modal-product-quick-review').modal('show', $(this));
            });

            $(document).on('show.bs.modal', '#modal-product-quick-review', function (e) {
                var $this     = $(this);
                var productId = $(e.relatedTarget).data('id');
                var template  = $('#js-product-modal-item').html();
                var $loader   = $this.find('.loader');
                $nextProduct  = $('.product-' + productId).next('.js-related-product');
                $prevProduct  = $('.product-' + productId).prev('.js-related-product');

                RISSB.fn.populateProductQuickPreviewModal(productId, '.js-related-product');

                $(document).on('click', '[data-toggle="modal"]', function (e) {
                    $('#modal-product-quick-review').modal('hide');
                });

                $(document).on('click', '.js-modal-previous-product', function (e) {
                    e.preventDefault();
                    RISSB.fn.populateProductQuickPreviewModal($prevProduct.find('.js-quick-preview').data('id'), '.js-related-product');
                });

                $(document).on('click', '.js-modal-next-product', function (e) {
                    e.preventDefault();
                    RISSB.fn.populateProductQuickPreviewModal($nextProduct.find('.js-quick-preview').data('id'), '.js-related-product');
                });
            });
        }
    });

})(jQuery);
